// removed by extract-text-webpack-plugin
module.exports = {"Game":"_1J0YO6JsdcSy5QCIsyWvNx"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Game/Game.scss
 ** module id = 394
 ** module chunks = 1
 **/